<template>
  <div :class="[getBackgroundClass(), 'py-5']">
    <div
      :class="[
        tripfinderViewModel.backgroundColorFilter,
        'facet-search-bar p-3 mx-auto',
      ]"
    >
      <div class="d-flex justify-content-between d-md-none">
        <button
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#tripfinderFacetSearch"
          aria-controls="tripfinderFacetSearch"
          class="btn btn-filter"
          @mousedown="preventFocus"
        >
          <span class="icon-filter"></span>
        </button>
        <button
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#tripfinderFacetSearch"
          aria-controls="tripfinderFacetSearch"
          class="btn btn-yellow text-uppercase fw-bold fs-7 rounded-pill"
          @mousedown="preventFocus"
        >
          Filtrer rejser
        </button>
      </div>
      <div
        id="tripfinderFacetSearch"
        :class="[
          tripfinderViewModel.backgroundColorFilter,
          'd-flex flex-md-row offcanvas justify-content-between',
        ]"
      >
        <div class="d-flex justify-content-end d-md-none mb-3">
          <button
            type="button"
            class="btn position-relative"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            @mousedown="preventFocus"
          >
            <span class="icon-close fs-6 position-absolute end-0"></span>
          </button>
        </div>
        <div
          :class="[
            { 'justify-content-around': tripfinderViewModel.showResultOnPage },
            'flex-grow-1 d-flex flex-column flex-md-row flex-wrap align-items-center position-relative',
          ]"
        >
          <template v-for="(filter, index) in computedFilters" :key="index">
            <button
              class="btn btn-lg facet-dropdown__button"
              type="button"
              data-bs-toggle="dropdown"
              data-bs-auto-close="outside"
              data-bs-reference="parent"
              data-bs-display="static"
              aria-expanded="false"
              @mousedown="preventFocus"
            >
              <span class="facet-dropdown__button-label">{{
                filter.title
              }}</span>
              <span class="icon-accordion_caret_down ms-2"></span>
              <span class="bar"></span>
            </button>
            <div
              :class="[
                tripfinderViewModel.backgroundColorFilter,
                'p-2 dropdown-menu',
              ]"
            >
              <div class="row">
                <div class="col-12 col-md-4">
                  <ul class="list-unstyled">
                    <facet-dropdown-list-item
                      v-for="(tag, index) in filter.tags[0]"
                      :key="index"
                      :tag="tag"
                      :cssBackground="tripfinderViewModel.filterCss"
                    />
                  </ul>
                </div>

                <div class="col-12 col-md-4">
                  <ul class="list-unstyled">
                    <facet-dropdown-list-item
                      v-for="(tag, index) in filter.tags[1]"
                      :key="index"
                      :tag="tag"
                      :cssBackground="tripfinderViewModel.filterCss"
                    />
                  </ul>
                </div>

                <div class="col-12 col-md-4">
                  <ul class="list-unstyled">
                    <facet-dropdown-list-item
                      v-for="(tag, index) in filter.tags[2]"
                      :key="index"
                      :tag="tag"
                      :cssBackground="tripfinderViewModel.filterCss"
                    />
                  </ul>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div
          class="d-flex justify-content-center align-items-start mt-2 mt-md-0"
          v-if="!tripfinderViewModel.showResultOnPage"
        >
          <button
            type="button"
            class="
              btn btn-yellow
              text-uppercase text-nowrap
              fw-bold
              fs-7
              rounded-pill
            "
            @mousedown="preventFocus"
            @click="showResults"
          >
            Vis resultat
          </button>
        </div>
      </div>
    </div>
  </div>
  <div :class="getBottomBackgroundClass()" v-if="tripfinderResult">
    <div class="d-flex flex-wrap facet-search-bar px-2 mx-auto">
      <button
        type="button"
        class="btn btn-tag"
        v-for="tag in selectedFilters"
        :key="tag.id"
        :title="['Fjern ' + tag.name]"
        @mousedown="preventFocus"
        @click="selectItem(tag)"
      >
        {{ tag.name }} <span class="ps-1">X</span>
      </button>
    </div>
  </div>
</template>
<script>
import FacetDropdownListItem from "./FacetDropdownListItem.vue";
export default {
  name: "FacetSearchBar",
  props: [],
  components: {
    FacetDropdownListItem,
  },
  computed: {
    tripfinderViewModel() {
      return this.$store.state.tripfinderViewModel;
    },
    tripfinderResult() {
      return this.$store.state.tripfinderResult;
    },
    computedFilters() {
      let result = [];
      this.tripfinderViewModel.filter.filters.forEach((filter) => {
        let tempFilter = {
          title: filter.title,
          tags: this.columnFilters(filter.tags),
        };
        result.push(tempFilter);
      });
      return result;
    },
    selectedFilters() {
      return this.$store.state.tripfinderSelectedFilters;
    },
  },
  methods: {
    showResults: function () {
      this.$store.dispatch("showTripfinderResults");
    },
    getBackgroundClass() {
      if (
        this.tripfinderViewModel.backgroundColorTop !==
        this.tripfinderViewModel.backgroundColorBottom
      ) {
        return (
          "bg__50__top-" +
          this.tripfinderViewModel.backgroundColorTop +
          "__bottom-" +
          this.tripfinderViewModel.backgroundColorBottom
        );
      } else {
        return this.getBottomBackgroundClass();
      }
    },
    getBottomBackgroundClass() {
      return "bg__" + this.tripfinderViewModel.backgroundColorBottom;
    },
    selectItem: function (tag) {
      this.$store.dispatch("selectItem", tag.id);
    },
    preventFocus: function (event) {
      // Prevents focus styling on click
      event.preventDefault();
    },
    columnFilters: function (items) {
      const n = 3; // number of columns
      const result = [[], [], []]; //we create it, then we'll fill it

      const filtersPerColumn = Math.ceil(items.length / 3);
      for (let filter = 0; filter < n; filter++) {
        for (let i = 0; i < filtersPerColumn; i++) {
          const value = items[i + filter * filtersPerColumn];
          if (!value) continue; //avoid adding "undefined" values
          value.firstLevel = true;
          result[filter].push(value);
        }
      }
      return result;
    },
  },
};
</script>
<style >
.btn-filter > span {
  font-size: 2.5rem;
}
</style>